import { render, staticRenderFns } from "./ChartPenghasilan.vue?vue&type=template&id=085b4a6e&"
import script from "./ChartPenghasilan.vue?vue&type=script&lang=js&"
export * from "./ChartPenghasilan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports